import { jsxs as r, jsx as l } from "react/jsx-runtime";
const o = (h) => /* @__PURE__ */ r(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...h,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M39.532 44.5v-3.014H24.468l.807 3.014h14.257Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "M41.212 48.045v.004H10.024V37.974h31.188v10.071l3.996-1.071V21.991h-35.18a4 4 0 0 0-4 4v22.053a4 4 0 0 0 4 4h32.256l-1.072-3.999ZM10.024 25.987h31.188v4.152H10.024v-4.152Zm0 6.15h31.188v3.84H10.024v-3.84Z"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentColor",
          d: "m54.974 35.405 2.997-.803V9.011H22.018a3 3 0 0 0-3 3v8.01h2.997v-8.013h32.959v23.398-.001ZM54.974 35.406h-7.767v2.997h8.571l-.803-2.997h-.001Z"
        }
      )
    ]
  }
);
export {
  o as MyPaymentCards
};
